import React from 'react'
import styled from '../../styled'
import { Icon_info_fill } from '@yanolja-rnd/ya-com-system-icon'
import { Typography } from '@yanolja-rnd/ya-com-core'
/**
 * NoticeBanner component
 * author: kangsik.lee
 */

type NoticeBannerImpl = React.FunctionComponent<{
  noticeBannerText?: string
}>

const Container = styled.div`
  display: flex;
  margin: 1.6rem 2rem 1.2rem 2rem;
  padding: 1.1rem 1.5rem 1rem 1.6rem;
  border-radius: 0.4rem;
  background-color: ${({ theme }) => theme.color.yaorange50};
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray900};
`

const Text = styled.div`
  padding-left: 0.4rem;
  width: 100%;
  ${Typography('body2.multiline').regular};
  color: ${({ theme }) => theme.color.gray900};
`

const IconInfoFill = styled(Icon_info_fill)`
  path {
    fill: ${({ theme }) => theme.color.yaorange};
  }
`

const NoticeBanner: NoticeBannerImpl = function ({ noticeBannerText }) {
  return (
    <Container>
      <IconInfoFill size={1.6} unit="rem" />
      <Text>{noticeBannerText}</Text>
    </Container>
  )
}

export default NoticeBanner
